import React from 'react';
import { PropTypes } from 'prop-types';

const Tab = ({ children }) => <>{children}</>;

export default Tab;
